module.exports = __webpack_public_path__ + "static/media/custum-calculation.28c124ba.jpg";